import type { ReactNode } from 'react';
import { SerifHeading } from '../primitives';
import styles from './LastSession.module.css';

export type LastSessionStat = {
  value: string;
  label: string;
};

type LastSessionProps = {
  /** "1600m repeats" */
  title: string;
  /** "Tough" — rendered in --signal marine */
  intensityLabel: string;
  stats: LastSessionStat[];
  note: ReactNode;
};

/**
 * Desktop-only narrow insight card — sits to the right of the CoachCard
 * in the insights row. Recap of the most recent non-today session with
 * reps/pace/HR and a one-line observation.
 *
 * Mobile composes this information differently (CoachStories chips);
 * desktop deserves its own card treatment per the spec.
 */
export function LastSession({ title, intensityLabel, stats, note }: LastSessionProps) {
  return (
    <section className={styles.card}>
      <div className={styles.kicker}>
        <span className={styles.dot} aria-hidden />
        <span>Last session</span>
      </div>
      <SerifHeading level="sm" as="div" className={styles.title}>
        {title} · <span className={styles.intensity}>{intensityLabel}</span>
      </SerifHeading>
      <div className={styles.row}>
        {stats.map((s) => (
          <div key={s.label} className={styles.stat}>
            <div className={`${styles.statValue} serif tnum`}>{s.value}</div>
            <div className={styles.statLabel}>{s.label}</div>
          </div>
        ))}
      </div>
      <div className={styles.note}>{note}</div>
    </section>
  );
}
